import { ensurePane, PANE_READY_EVENT } from '../../../components/modules/booking/pane';

class BookingGatherTab {
  constructor() {
    this.pane = document.getElementById('gather-content');
    this.bookingButton = document.querySelector('.book-now__button');
    this.init();
  }

  /**
   * The Gather pane may still be in its <template> (see booking/pane.js).
   * @param {boolean} render render it when needed
   * @returns {Element|null}
   */
  getContainer(render) {
    if (render) {
      ensurePane(this.pane);
    }

    return this.pane.querySelector('.js-gather-tab');
  }

  init() {
    if (!this.pane) {
      return;
    }

    const container = this.getContainer(false);

    if (container) {
      container.dataset.brandVenuesRfp = 'false';
    }

    document.querySelectorAll('[data-rfp]').forEach((link) => {
      link.addEventListener('click', () => {
        const { hotelId, additionalHotelId } = link.closest('.brand-venues__card').dataset;
        const actualHotelId = additionalHotelId ?? hotelId;
        const gatherContainer = this.getContainer(true);

        if (!gatherContainer) {
          return;
        }

        const eventProperty = gatherContainer.querySelector('.js-booking-event-property');
        if (eventProperty.querySelector(`[value="${actualHotelId}"]`) && actualHotelId) {
          eventProperty.value = actualHotelId;
        }

        gatherContainer.dataset.brandVenuesRfp = 'true';
      });
    });

    // Runs after GatherTab has set the default property on the freshly rendered form.
    this.pane.addEventListener(PANE_READY_EVENT, () => {
      if (this.resetPending) {
        this.resetPending = false;
        BookingGatherTab.reset(this.getContainer(false));
      }
    });

    this.bookingButton.addEventListener('click', () => {
      const gatherContainer = this.getContainer(false);

      if (gatherContainer) {
        BookingGatherTab.reset(gatherContainer);
      } else {
        // Form not rendered yet: reset it when it is.
        this.resetPending = true;
      }
    });
  }

  static reset(gatherContainer) {
    if (!gatherContainer) {
      return;
    }

    const eventProperty = gatherContainer.querySelector('.js-booking-event-property');
    eventProperty.value = gatherContainer.dataset.defaultPropertyId || '';
    Object.assign(gatherContainer.dataset, { brandVenuesRfp: 'false' });
  }
}

export default BookingGatherTab;
